/* eslint-disable import/prefer-default-export */
import { CompletedInterviewsListResponse, CompletedInterviewsListTable } from './types';

export function convertApiDataToTable(apiResponse: CompletedInterviewsListResponse[]) {
  const tableData: CompletedInterviewsListTable[] = [];
  apiResponse?.map((item) => {
    tableData.push({
      jobOrderId: item.jobOrderId,
      lastName: item.lastName,
      encryptedMail: item.encryptedMail,
      oldScore: item.oldScore,
      score: item.score,
      clientId: item.clientId,
      techSkill: item.techSkill,
      oldTechSkill: item.oldTechSkill,
      jobTitle: item.jobTitle,
      updatedDate: item.updatedDate,
      interviewPosition: item.interviewPosition,
      environmentalName: item.environmentalName,
      skills: item.skills,
      organizationId: item.organizationId,
      emailAddress: item.emailAddress,
      payType: item.payType,
      communicationSkills: item.communicationSkills,
      fileURL: item.fileURL,
      oldCommunicationSkills: item.oldCommunicationSkills,
      interviewerId: item.interviewerId,
      updatedBy: item.updatedBy,
      payRate: item.payRate,
      interviewDate: item.interviewDate,
      candidateTitle: item.candidateTitle,
      interviewMode: item.interviewMode,
      jobId: item.jobId,
      firstName: item.firstName,
      interviewId: item.interviewId,
      createdDate: item.createdDate,
      phoneNumber: item.phoneNumber,
      createdBy: item.createdBy,
      candidateId: item.candidateId,
      MLiveInterviewerLink: item.MLiveInterviewerLink,
      pannareportURL: item.pannareportURL,
      oldPannareportURL: item.oldPannareportURL,
      timeSlot: item.timeSlot,
      startTime: item.startTime,
      endTime: item.endTime,
      interviewComments: item.interviewComments,
      timeZone: item.timeZone,
      MLivereportURL: item.MLivereportURL,
      oldMLivereportURL: item.oldMLivereportURL,
      hashKey: item.hashKey,
      mliveInterviewComments: item.mliveInterviewComments,
      pannaInterviewComments: item.pannaInterviewComments,
    });

    return item;
  });

  return tableData;
}
